const amikacin = {
  path: "Amikacin_initial_dose_calculator#Amikacin_initial_dose_calculator",
  mapTo: "/calculator/idcalc?preset=true&drugType=amikacin",
};

const gentamicin = {
  path: "Gentamicin_initial_dose_calculator#Gentamicin_initial_dose_calculator",
  mapTo: "/calculator/idcalc?preset=true&drugType=gentamicin",
};

const tobramycin = {
  path: "Tobramycin_initial_dose_calculator#Tobramycin_initial_dose_calculator",
  mapTo: "/calculator/idcalc?preset=true&drugType=tobramycin",
};

const calculatorUrlMap = [
  amikacin,
  gentamicin,
  tobramycin
]

export const handleCalculatorUrls = (msPath) => {
  if (!msPath) return msPath;

  const target = calculatorUrlMap.find(item =>
    msPath.startsWith("/viewTopic") &&
    msPath.toLowerCase().includes(item.path.toLowerCase())
  );

  return target?.mapTo ?? msPath;
};